// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1_Ze_","cls2":"Timer-cls2_Fgu Timer-cls1_Ze_"};